import axios from "axios";

import { IClient } from "@/shared/model/client.model";

const baseApiUrl = "api/clients";
export default class ClientService {
  public findBy360(encryptedId: string): Promise<IClient[]> {
    return new Promise<IClient[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/find-by-360/${encryptedId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
